import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Tabs, TabsProps } from 'antd';
import { NotificationsList } from './NotificationsList';
import cx from 'classnames';
import { useUiServerNotificationsCount } from '../../../hooks';
import { getServerNotificationsFirstPage } from '../../../middleware';
import { tI } from '../../../translate';
import { Catcher } from '../../Catcher';
import Styles from '../m_styles.less';

enum NotificationsType {
    UNREAD = 'unRead',
    READ = 'read',
}

export const Notifications: React.FC = observer(() => {
    const [currentTab, setTab] = useState<NotificationsType>(NotificationsType.UNREAD);
    const { countRead, countUnRead } = useUiServerNotificationsCount();

    const handleTabChange = (value: string): void => {
        if (value !== currentTab) {
            setTab(value as NotificationsType);
        }
    };

    useEffect(() => {
        const isShowRead = currentTab === NotificationsType.READ;
        getServerNotificationsFirstPage(isShowRead);
    }, [currentTab]);

    const items: TabsProps['items'] = [
        {
            key: NotificationsType.UNREAD,
            label: `${tI('Unread')} ${countUnRead}`,
        },
        {
            key: NotificationsType.READ,
            label: `${tI('Read')} ${countRead}`,
        },
    ];

    return (
        <Catcher>
            <div className={Styles.tabContainer}>
                <Tabs
                    activeKey={currentTab}
                    centered={true}
                    className={cx(Styles.tabRight, Styles.tabTopOnly)}
                    defaultActiveKey={NotificationsType.UNREAD}
                    items={items}
                    onChange={handleTabChange}
                />
                <NotificationsList isShowRead={currentTab === NotificationsType.READ} />
            </div>
        </Catcher>
    );
});
